<template src="./templates/MainTemplate.html">
</template>

<script>
import OverlayClassesModal from './templates/OverlayClassesModal.vue';
import Panel from './Panel.vue';
import FooterTutorial from './templates/FooterTutorial.vue';
import mountMixin from './mixins/mount.js';
import initMixin from './mixins/init.js';
import useMixin from './mixins/use.js';
import finishMixin from './mixins/finish.js';
import '@/plugins/ui.js'

export default {
    components: {
		OverlayClassesModal,
        Panel,
		FooterTutorial,
    },
	mixins: [mountMixin, initMixin, useMixin, finishMixin],
    data() {
        return {
            title: {}, // { 'Ma_HP': 1, 'Ma_lop': 2,... }
            titleTrans: {
                subjectCode: 'Mã_HP',
                classCode: 'Mã_lớp',
                classCode2: 'Mã_lớp_kèm',
                subjectName: 'Tên_HP',
                creditsInfo: 'Khối_lượng',
                day: 'Thứ',
                time: 'Thời_gian',
                week: 'Tuần',
                room: 'Phòng',
                needExperiment: 'Cần_TN',
                status: 'Trạng_thái',
                classType: 'Loại_lớp',
                programName: 'Mã_QL',
				color: 'color',
            },
            programs: ['CT CHUẨN', 'Elitech', 'SIE'],
			fileProgramTitle: null,
            subjectCodes: [],
            subjectNameMap: {}, // { 'Ma_HP': 'Ten_lop' }
            jsonTable: {}, // {'subjectCode': {'classCode': [row], 'subjectName': 'subjectName'}} // if jsonTable is not empty, then you are ready to choose class
            rawTable: [],
            rawTitle: [], // ['Ma_HP', 'Ma_lop',...]
            tableTime: [],
            isChoosing: {},
            choosingSubject: null,
            layer: {}, // { 'day': { 'time': ['chosenClassesIndex'] } }
            chosenClasses: [],
            programName: "CT CHUẨN",
            panelRatio: 2,
            changeTitle: false,
            overlayClasses: [],
            isImported: false,
            importTable: [],
            sugestSubjects:[],
            currentSugestSubject: -1,
            innerWidth: 0,
            fileList: [],
            hasLocalTimeTable: false,
            drawer: false,
			expectedTimeTableName: '',
            university: 'HUST',
            uniTableScale: 1,
            subjecCodeMinLength: 6,
        }
    },
    methods: {
        clickToAddSubjectToRegisterList(subject, index) {
            this.$refs['subjectCode'].value = this.getRowInfo(subject, 'subjectCode')
            this.currentSugestSubject = index
            this.addSubjectToRegisterList()
        },
        chooseSugestion(increment) {
            if(this.sugestSubjects.length == 0) {
                console.log('No sugest subjects')
                return
            }
            this.currentSugestSubject = (this.currentSugestSubject + increment + this.sugestSubjects.length) % this.sugestSubjects.length
            this.$refs['subjectCode'].value = this.getRowInfo(this.sugestSubjects[this.currentSugestSubject], 'subjectCode')
			this.$refs['sugestSubjectsHolder'].scrollTop = this.currentSugestSubject * 49
        },
        uploadButtonClick(event) {
            if(event.type == 'click' && !event.isTrusted) {
                console.log('Programmatic click uploadButtonClick')
                return // if clicked programatically then ignore
            }
            this.isImported = false
        },
		initTable() {
			this.findTitle(this.rawTable)
			// this.initSubjectTree()
		},
        resetTable() {
            if(this.$refs['result']) this.$refs['result'].innerHTML = ''
            if(this.chosenClasses.length > 0){
                this.chosenClasses.forEach((val, index) => {
                    if(!val) return
                    this.deletePanel(index, this.getRowInfo(val.classInfo, 'day'))
                })
            }
        },
        reAddTable() { // re-add to match new table time
            let chosen = [...this.chosenClasses]
            this.resetTable()

            chosen.forEach(val => {
                if(!val) return
                let indexOfRowSubjectCode = this.subjectCodes.indexOf(this.getRowInfo(val.classInfo, 'subjectCode'))
                if(indexOfRowSubjectCode != -1 && this.isSameProgram(val.classInfo) || this.isImported) this.chooseClass([val.classInfo]) // only classes that still being wanted
            })
        },
        findClasses() {
            this.addSubjectToRegisterList()
            this.filterSubject()
            this.reAddTable()
        },
        importFile() {
            this.filterSubject()
            this.importTable = [...this.rawTable]
            this.importTable.forEach(val => {
                let subjectCode = this.getRowInfo(val, 'subjectCode')
                if(this.subjectCodes.indexOf(subjectCode) == -1){
                    this.subjectCodes.push(subjectCode)
                    this.subjectNameMap[subjectCode] = this.getRowInfo(val, 'subjectName')
                }
                this.chooseClass([val])
            })
            this.rawTable = []
            // this.jsonTable = {}
        },
        importButtonClick() {
            this.isImported = true
            document.querySelector('input[type=file]').click()
        },
        importFromLocal() {
            this.isImported = true
            this.rawTable = JSON.parse(localStorage.getItem('timeTable')) ?? []
            this.initTable()
            setTimeout(() =>{ // Time for DOM to update
                this.importFile()
                this.$toast.success('Đã nhập từ bộ nhớ của Browser')
            }, 0)
        },
        getChosenClassTypes(subjectCode) {
            let ans = this.chosenClasses.filter(val => val && this.getRowInfo(val.classInfo, 'subjectCode') == subjectCode)
            if(ans.length == 0) return ''
            return ans.reduce((str, curr) => {
                    let classType = this.getRowInfo(curr.classInfo, 'classType')
                    if(str.indexOf(classType) != -1) return str
                    return str + ' ' + classType
                }, 'Đã chọn: ')
        },
        isDoneScheduling() {
            let result = this.$refs['result']?.innerHTML
            return result && result.indexOf('trùng') == -1
        },
        isTableVisible() {
            return Object.values(this.jsonTable).length > 0 || this.isImported
        },
        getRowInfo(data, field) {
            let info = data[this.title[this.titleTrans[field]]]
            if(typeof info == 'number') info = '' + info
            if(typeof info != 'string') return ''
            return info
        },
		isSameProgram(data) {
			if (this.programName == "All") return true

			if (this.fileProgramTitle === null) {
				let nameSpace = this.programs
				for (let title of this.rawTitle) {
					let info = data[this.title[title]]
					if (nameSpace.indexOf(info) != -1) {
						this.fileProgramTitle = title
					}
				}
				if (this.fileProgramTitle === null) {
					this.$toast.error('Không tìm thấy cột "Chương trình học".')
				}
			}
			let rowProgramName = data[this.title[this.fileProgramTitle]]
            return rowProgramName && rowProgramName.toLowerCase() == this.programName.toLowerCase()
		},
    },
    async created() {
        this.hasLocalTimeTable = localStorage.getItem('timeTable') ? true : false
		this.expectedTimeTableName = localStorage.getItem('expectedTimeTableName') ?? ''
		this.initTableHeight()
    },
    mounted() {
        this.innerWidth = (window.innerHeight > window.innerWidth) ? 2 * window.innerWidth : window.innerWidth
        window.onbeforeunload = (event) => {
            if(this.chosenClasses.length == 0) return
            event.preventDefault()
            return event.returnValue = 'Hãy nhớ lưu lại TKB đã sắp xếp nhé!';
        }
        document.querySelector('html').style.minWidth = 'fit-content'
		if(typeof $ === 'undefined') {
			alert('Điều kiện mạng không ổn định, xin hãy load lại trang!')
		}
    },
    destroyed() {
        this.$swal.close()
    },
}
</script>

<style scoped>
    table{
        width: 100%;
        text-align: center;
    }
    .choosable{
        background:#80B4FBD0;
        border-left: 1px solid;
        border-right: 1px solid;
    }
    .translate-up{
        transform: translateY(-62%);
    }
    .z-top{
        z-index: 100;
    }
    .fixed-50{
        position: fixed;
        top: 50%;
        background: white;
        z-index: 100;
    }
    .select-class:hover{
        color: yellowgreen;
    }
    .subject-sugest{
        position: absolute;
        z-index: 100;
		max-height: 250px;
    	overflow-y: scroll;
    }
    .list-group-item:hover{
        color: rgb(41, 147, 233);
    }
	.list-group-item.active:hover {
		color: white;
	}
    .dotted-border:hover{
        border-top: 1px dotted #b1acac;
    }
    .upload >>> .el-upload.el-upload--text {
        width: 100%;
    }
    .upload >>> .el-upload-dragger {
        width: 100%;
        height: 38px;
		animation-name: blinking;
  		animation-duration: 2s;
		animation-iteration-count: infinite;
    }
	@keyframes blinking {
		50% {
			color: #495057;
			background-color: #fff;
			border-color: #80bdff;
			outline: 0;
			box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
		}
	}
    .subject-code {
        height: 40px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        background-color: #fafafa;
        cursor: pointer;
        box-shadow: 0 1px 0 #091e4240;
        margin-bottom: 8px;
        white-space: nowrap;
    }
    .subject-code:hover {
        box-shadow: 0px 0px 12px 0 rgba(0, 0, 0, .25) inset;
    }
    .subject-code.active {
        background: #d8d5e082;
    }
    .subject-code .overflow-auto::-webkit-scrollbar {
        display: none;
    }
    .drawer-button {
        position: fixed;
        top: 50%;
        left: 10px;
        width:30px;
        height:30px;
        border-radius: 100%;
    }
	.font-10 {
		font-size: 10px;
	}
	ul::-webkit-scrollbar-track
	{
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
		background-color: #F5F5F5;
	}

	ul::-webkit-scrollbar
	{
		width: 12px;
		background-color: #F5F5F5;
	}

	ul::-webkit-scrollbar-thumb
	{
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
		background-color: #555;
	}
</style>